import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { GrayBadge } from '@PipelineDeals/shared-react-components'
import copyToClipboard from 'modules/copyToClipboard'

const Container = styled.div`
  cursor: pointer;
  width: max-content;
`

const IdPrefix = styled.span`
  margin-right: 2px;

  @media (max-width: 1200px) {
    display: none;
  }
`

const IdBadge = ({ id }) => {
  const handleClick = () => {
    copyToClipboard(id, 'ID copied to clipboard!')
  }

  return (
    <Container onClick={handleClick}>
      <GrayBadge
        content={<><IdPrefix>ID: </IdPrefix>{id}</>}
        trailingContent={<i className="far fa-copy" />}
      />
    </Container>
  )
}

IdBadge.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
}

export default IdBadge
